module.exports = __webpack_public_path__ + "img/provider4.189f052c.png";